import React, { Component } from "react";
import axios from "axios";

import { Card, Grid, TextField, Typography } from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import { Navigate } from "react-router-dom";

// ✅ MEDIA MODAL
import MediaPickerModal from "Main/Modals/MediaModal";

export default class AddBlogs extends Component {

  state = {
    title: "",
    meta_key: "",
    meta_description: "",
    img_alt_text: "",
    blog_content: "",

    selectedImage: null,
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  // 🔹 Input handler
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // 🔹 Editor
  handleDescription = (content) => {
    this.setState({ blog_content: content });
  };

  // 🔹 Submit
  handleSubmit = (e) => {
    e.preventDefault();

    const {
      title,
      meta_key,
      meta_description,
      img_alt_text,
      blog_content,
      selectedImage,
    } = this.state;

    if (!title || !blog_content) {
      return this.setState({
        notification: true,
        message: "Title and content are required",
      });
    }

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      title,
      meta_key,
      meta_description,
      img_alt_text,
      blog_content,
      image_id: selectedImage.id, // ✅ important
    };

    this.setState({ loading: true });

    if (init() === "success") {
      axios
        .post(Constants.postUrls.createBlog, payload)
        .then((resp) => {
          this.setState({
            notification: true,
            message: resp.data.message,
            loading: false,
          });

          setTimeout(() => {
            this.setState({ redirect: true });
          }, 2000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response?.data?.message || "Error",
            loading: false,
          });
        });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/blogs" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>

            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <Typography variant="h6" color="white">
                Create Blog
              </Typography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* Title */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Blog Title"
                      name="title"
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* Image Picker */}
                  <Grid item xs={12} md={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() =>
                        this.setState({ showMediaModal: true })
                      }
                    >
                      Select Image
                    </MDButton>

                    {/* Preview */}
                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 100,
                          height: 100,
                          marginTop: 10,
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </Grid>

                  {/* Alt Text */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Image Alt Text"
                      name="img_alt_text"
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* Meta Key */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Meta Keywords"
                      name="meta_key"
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* Meta Description */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Meta Description"
                      name="meta_description"
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* Editor */}
                  <Grid item xs={12}>
                    <SunEditor
                       setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["font", "fontSize"],
                          ["paragraphStyle", "blockquote"],
                          [
                            "bold",
                            "underline",
                            "italic",
                            "strike",
                            "subscript",
                            "superscript",
                          ],
                          ["fontColor", "hiliteColor"],
                          ["align", "list", "lineHeight"],
                          ["outdent", "indent"],
                          ["table", "horizontalRule", "link", "image", "video"],
                          ["imageGallery"],
                          ["preview", "print"],
                          ["removeFormat"],
                        ],
                        defaultTag: "div",
                        height: 120,
                        showPathLabel: false,
                      }}
                      value={this.state.blog_content}
                      onChange={this.handleDescription}
                    />
                  </Grid>

                  {/* Submit */}
                  <Grid item xs={12}>
                    <MDButton variant="contained" color="info" type="submit">
                      {this.state.loading ? "Creating..." : "Create Blog"}
                    </MDButton>
                  </Grid>

                </Grid>
              </form>
            </MDBox>

            {/* Snackbar */}
            <MDSnackbar
              color="success"
              title="Blogs"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* MEDIA MODAL */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />

          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}